
const Error = () => {
    return (
        <div>
            <div>I'm afraid that something went wrong. We are investigating the issue.</div>
            <div>In the meanwhile, try clearing your cache and cookies and reloading the website. Alternatively, try opening Tipl in a private browsing window.</div>
        </div>
    );
};

export default Error;
